<template>
    <main>
        <section class="hero">
            <img src="~@/assets/img/logo.svg" class="tw-mx-auto tw-text-center tw-pb-6 tw-pt-5 lg:tw-pb-20 lg:tw-pt-10">
            <div class="tw-container">
                <h1 class="main-title tw-text-white tw-text-center tw-pb-4 lg:tw-pb-12">A SUA PRÓXIMA<br><span>VIAGEM ESTÁ A CHEGAR …</span></h1>
            </div>
            <div class="form-big-container">
                <div class="tw-container">
                    <div class="form-title lg:tw-hidden">
                        <h2 class="tw-text-white tw-uppercase tw-text-xs tw-text-center">Participe e ganhe<br>um <span>vale de viagem!</span></h2>
                    </div>
                    <div class="form-title-desktop tw-hidden lg:tw-block">
                        <h2 class="tw-text-white tw-uppercase tw-text-center">Participe e ganhe um <span>vale de viagem!</span></h2>
                    </div>
                </div>

                <div class="form-container tw-bg-white">
                    <div class="tw-container">
                        <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                        <FormSuccess v-if="$store.state.formSuccess && !$store.state.formError" />
                        <FormError v-if="$store.state.formError && !$store.state.formSuccess" />
                    </div>
                </div>
            </div>

        </section>

        <section class="how-to tw-w-full tw-relative">
            <div class="tw-container">
                <h2 class="tw-text-center tw-uppercase tw-text-2xl lg:tw-text-4xl tw-pb-8 lg:tw-pb-16">Como participar</h2>
                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 lg:tw-gap-5">
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-start tw-mb-12 lg:tw-mb-0">
                        <div class="tw-relative" data-attr="1"><img src="~@/assets/img/icons/grid-1.svg"></div>
                        <h3 class="tw-uppercase tw-text-xl tw-py-3 tw-text-center">Submeta a sua frase</h3>
                        <p class="tw-text-sm tw-text-center">Envie uma frase criativa, onde inclua as<br>palavras INTERPASS e VIAJAR.</p>
                    </div>

                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-start tw-mb-12 lg:tw-mb-0">
                        <div class="tw-relative" data-attr="2"><img src="~@/assets/img/icons/grid-2.svg"></div>
                        <h3 class="tw-uppercase tw-text-xl tw-py-3 tw-text-center">Registe-se</h3>
                        <p class="tw-text-sm tw-text-center">Preencha o formulário acima com os seus<br>dados pessoais para criar o seu registo.</p>
                    </div>

                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-start tw-mb-12 lg:tw-mb-0">
                        <div class="tw-relative" data-attr="3"><img src="~@/assets/img/icons/grid-3.svg"></div>
                        <h3 class="tw-uppercase tw-text-xl tw-py-3 tw-text-center">Participe</h3>
                        <p class="tw-text-sm tw-text-center">Passatempo válido até 30 de Novembro de 2022.<br>O prémio tem a validade de 1 ano.</p>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
